import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PlaceSuggest } from '@fs/zion-standards'
import PropTypes from 'prop-types'
import { deepCopy, isDeepEqual } from '../../util/Utils'

export function initPlaceStandards(originalPlace, standardPlace, standardPlaceId) {
  const place = {
    originalText: originalPlace || '',
    standard: {
      standardizedText: standardPlace || '',
      id: standardPlaceId || null,
    },
  }
  return deepCopy(place)
}

function makeValidMessage(selectedItem) {
  const standardizedText = selectedItem?.standard?.standardizedText
  if (!standardizedText) {
    return undefined
  }
  return standardizedText
}

function makeWarningMessage(selectedItem, placeTypes) {
  if (
    placeTypes.length === 0 ||
    !selectedItem?.standard?.placeType ||
    placeTypes.some((pT) => pT === selectedItem.standard.placeType)
  ) {
    return null
  }
  let placeTypesInMessage = ''
  placeTypes.forEach((placeType, index, array) => {
    if (index === array.length - 2) {
      placeTypesInMessage += `${placeType} or `
    } else if (index === array.length - 1) {
      placeTypesInMessage += `${placeType}`
    } else {
      placeTypesInMessage += `${placeType},`
    }
  })

  return placeTypesInMessage
}

// selecting original text in first dropdown means: I want to save the original text. Selection has both originalText and standardText defined. the standardText is chosen for you
// selecting standard from second dropdown means: I want to save the original text, but I did not like the first standards suggestion. Selection has both originalText and standardText defined
// selecting standard text from first dropdown means: I do not want to save the original text. Selection has originalText null and standardText defined
export default function DmcPlaceStandards({
  selectedItem,
  setSelectedItem,
  editable,
  placeTypes = [],
  label = undefined,
  idType,
}) {
  const { t } = useTranslation()
  const standardizedText = makeValidMessage(selectedItem)
  const [validMessage, setValidMessage] = useState(
    t('standards.valid', { defaultValue: `Standardized: ${standardizedText}`, message: standardizedText })
  )
  const placeTypesInMessage = makeWarningMessage(selectedItem, placeTypes)
  const warningValidate = t('standards.warning', {
    defaultValue: `Requires place type of ${placeTypesInMessage}`,
    message: placeTypesInMessage,
  })

  useEffect(() => {
    setValidMessage(
      t('standards.valid', { defaultValue: `Standardized: ${standardizedText}`, message: standardizedText })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem?.standard?.standardizedText])

  return (
    <PlaceSuggest
      id={`${idType}Place`}
      label={label}
      disabled={!editable}
      selectedItem={selectedItem}
      onSuggestionSelected={(newSelectedItem) => {
        !isDeepEqual(selectedItem, newSelectedItem) && setSelectedItem(newSelectedItem)
      }}
      standardize
      validMessage={standardizedText && validMessage}
      errorMessage={placeTypesInMessage && warningValidate}
    />
  )
}

DmcPlaceStandards.propTypes = {
  selectedItem: PropTypes.shape({
    originalText: PropTypes.string,
    standard: PropTypes.shape({
      id: PropTypes.number,
      standardizedText: PropTypes.string,
      placeType: PropTypes.string,
      yearRange: PropTypes.string,
      location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
      }),
    }),
  }),
  setSelectedItem: PropTypes.func,
}
